import React, { useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DescriptionIcon from "@mui/icons-material/Description";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DownloadingIcon from "@mui/icons-material/Downloading";

const VoiceMaker = () => {
  const [activeButton, setActiveButton] = useState("alloy"); // Track the active button

  const buttons = ["alloy", "echo", "fable", "nova", "onyx", "shimmer"]; // Button names

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName); // Update the active button
  };
  return (
    <div className="px-4 py-6">
      <div className="p-[14px] shadow-cs rounded-lg mb-[20px] bg-white">
        <h1 className="text-[16px] md:text-[18px] cursor-pointer font-medium text-gray-900 mb-2">
          Voice Maker
        </h1>
        <div className="flex items-center text-sm text-gray-500">
          <a href="/" className="hover:text-gray-700">
            Home
          </a>
          <span className="mx-2">
            <ChevronRightIcon />
          </span>
          <span className="text-gray-700">Voice Maker</span>
        </div>
      </div>
      <div className="flex items-center mb-[20px] gap-[16px]">
        <button className="pt-[8px] pb-[8px] pl-[16px] pr-[16px] font-medium   rounded-2xl shadow-cs bg-white text-[13px] md:text-[14px] text-[#27004a]">
          geminiAi: 99157
        </button>
        <button className="pt-[8px] pb-[8px] pl-[16px] pr-[16px] font-medium  rounded-2xl shadow-cs bg-white text-[13px] md:text-[14px] text-[#008000]">
          OpenAi: 76904
        </button>
      </div>
      <div className="p-[14px] shadow-cs bg-white rounded-lg mb-[20px]">
        <div className="mb-[10px]">
          <textarea
            className="bg-[#e9e9e9] w-full h-[86px] rounded-xl p-[8px] focus-visible:outline-none "
            type="text"
            placeholder="Enter your text"
          />
        </div>
        <div className="flex items-center justify-between flex-wrap gap-[16px]">
          <div className="flex items-center gap-[16px] flex-wrap whitespace-nowrap">
            {buttons.map((button) => (
              <button
                key={button}
                className={`rounded-2xl whitespace-nowrap text-[11px] md:text-[14px] pl-[18px] pr-[18px] font-medium pt-[5px] pb-[5px] shadow-cs 
                  ${
                    activeButton === button
                      ? "bg-[#27004a] text-white"
                      : "text-black"
                  }`}
                onClick={() => handleButtonClick(button)}
              >
                {button}
              </button>
            ))}
          </div>
          <button className="second-btn">Generate Voice</button>
        </div>
      </div>
      <div className="space-y-4">
        {[1].map((item) => (
          <div
            key={item}
            className="flex items-center justify-between p-4 bg-white rounded-lg shadow-cs"
          >
            <div className="flex items-center gap-4">
              <div className="p-2 bg-gray-100 rounded">
                <DescriptionIcon className="text-[#27004a]" />
              </div>
              <div>
                <p className="  text-[14px] md:font-medium md:text-[15px] ">
                  1 months ago
                </p>
                <p className="text-sm text-gray-600">Text</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <button className="p-2 text-gray-600 hover:text-gray-800 transition-colors">
                <DeleteOutlineIcon />
              </button>
              <button className="p-2 text-gray-600 hover:text-gray-800 transition-colors">
                <DownloadingIcon />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VoiceMaker;
